import { render, staticRenderFns } from "./Avataaars.vue?vue&type=template&id=73ae21c6&scoped=true&"
import script from "./Avataaars.vue?vue&type=script&lang=js&"
export * from "./Avataaars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae21c6",
  null
  
)

export default component.exports